import React from "react";
import {
  STATS_FRAME_1,
  STATS_FRAME_2,
  STATS_FRAME_3,
  STATS_FRAME_4,
  STATS_FRAME_5,
  STATS_FRAME_6,
  STATS_FRAME_7,
  ADMIN_PLACEHOLDER,
} from "../../../assets";
import { Plus } from "lucide-react";

const stats = [
  {
    title: "Total number of users",
    value: "300",

    highlighted: true,
  },
  {
    title: "Total number of case folders",
    value: "300",
    icon: STATS_FRAME_1,
  },
  {
    title: "Total Number of Cases Concluded",
    value: "300",
    icon: STATS_FRAME_2,
  },
  {
    title: "Total number of cause list",
    value: "300",
    icon: STATS_FRAME_3,
  },
  {
    title: "Accounts pending approval",
    value: "300",
    icon: STATS_FRAME_4,
  },
  {
    title: "Total number of queries",
    value: "300",
    icon: STATS_FRAME_5,
  },
  {
    title: "Total number pending queries",
    value: "300",
    icon: STATS_FRAME_6,
  },
  {
    title: "Total number of resolved query",
    value: "300",
    icon: STATS_FRAME_7,
  },
];

const chartData = [
  { month: "Jan", caseFolders: 150, payments: 200 },
  { month: "Feb", caseFolders: 650, payments: 450 },
  { month: "Mar", caseFolders: 680, payments: 600 },
  { month: "Apr", caseFolders: 620, payments: 520 },
  { month: "May", caseFolders: 480, payments: 460 },
  { month: "Jun", caseFolders: 420, payments: 480 },
  { month: "Jul", caseFolders: 700, payments: 620 },
  { month: "Aug", caseFolders: 760, payments: 680 },
  { month: "Sep", caseFolders: 400, payments: 430 },
  { month: "Oct", caseFolders: 580, payments: 720 },
  { month: "Nov", caseFolders: 780, payments: 710 },
  { month: "Dec", caseFolders: 690, payments: 670 },
];

const avatars = [
  "https://randomuser.me/api/portraits/men/32.jpg",
  "https://randomuser.me/api/portraits/men/44.jpg",
  "https://randomuser.me/api/portraits/women/68.jpg",
];

const Overview = () => {
  return (
    <div className="px-5 py-8 min-h-screen">
      <div className="w-full grid grid-cols-4 gap-x-3 gap-y-5 mb-8">
        {stats.map((stat, index) => (
          <div
            key={index}
            className={`w-full h-full rounded-xl p-5 flex flex-col items-start gap-y-2 ${stat.highlighted && "bg-[#23A863]"}`}
            style={{
              boxShadow: "-2px -2px 2px 3px #7A7A7A1A",
            }}
          >
            {stat.highlighted ? (
              <div className="flex items-center">
                {avatars.map((avatar, index) => (
                  <div
                    key={index}
                    className="relative"
                    style={{ marginLeft: index !== 0 ? "-12px" : "0px" }}
                  >
                    <img
                      src={avatar}
                      alt="avatar"
                      className="w-[37px] h-[37px] rounded-full object-cover border border-white shadow-md"
                    />
                  </div>
                ))}

                {/* Add Button */}
                <div className="relative" style={{ marginLeft: "-12px" }}>
                  <div className="w-[37px] h-[37px] rounded-full bg-[#FFFFFF] border border-white flex items-center justify-center shadow-md cursor-pointer hover:bg-gray-300 transition">
                    <Plus className="w-[11.67px] h-[11.67px] text-blue-600" />
                  </div>
                </div>
              </div>
            ) : (
              <img src={stat.icon} className="w-[36px] h-[36px]" alt="" />
            )}
            <span
              className={`text-[#9A9A9A] text-xs text-nowrap ${stat.highlighted && "text-[#FFFFFFC7]"}`}
            >
              {stat.title}
            </span>
            <span
              className={`text-2xl font-bold ${stat.highlighted && "text-white"}`}
            >
              {stat.value}
            </span>
          </div>
        ))}
      </div>

      <div
        className="bg-white rounded-3xl px-8 py-8"
        style={{
          boxShadow: "-2px -2px 2px 3px #7A7A7A1A",
        }}
      >
        <div className="flex items-center justify-between mb-4">
          <h2 className="text-lg font-semibold text-[#6B7280]">
            Case folder and Payments summary
          </h2>
          <div className="flex items-center gap-6 text-sm">
            <div className="flex items-center gap-2">
              <span className="w-3 h-3 rounded-full bg-[#2563EB]" />
              <span className="text-[#111827]">Total case folders</span>
            </div>
            <div className="flex items-center gap-2">
              <span className="w-3 h-3 rounded-full bg-[#00B074]" />
              <span className="text-[#111827]">Total payment</span>
            </div>
          </div>
        </div>

        <div className="relative h-[320px] w-full overflow-hidden">
          <svg viewBox="0 0 1100 320" className="w-full h-full">
            <defs>
              <linearGradient id="gridLine" x1="0" y1="0" x2="0" y2="1">
                <stop offset="0%" stopColor="#E5E7EB" stopOpacity="0.6" />
                <stop offset="100%" stopColor="#E5E7EB" stopOpacity="0.3" />
              </linearGradient>
            </defs>

            <rect x="0" y="0" width="1100" height="320" fill="white" rx="24" />

            {Array.from({ length: 6 }).map((_, i) => {
              const y = 40 + i * 40;
              return (
                <line
                  key={i}
                  x1="40"
                  x2="1040"
                  y1={y}
                  y2={y}
                  stroke="url(#gridLine)"
                  strokeWidth="1"
                />
              );
            })}

            {Array.from({ length: 12 }).map((_, i) => {
              const x = 80 + i * 80;
              return (
                <line
                  key={i}
                  x1={x}
                  x2={x}
                  y1="40"
                  y2="280"
                  stroke="#F3F4F6"
                  strokeWidth="1"
                />
              );
            })}

            <polyline
              fill="none"
              stroke="#2563EB"
              strokeWidth="3"
              strokeLinecap="round"
              strokeLinejoin="round"
              points={chartData
                .map((item, index) => {
                  const x = 80 + index * 80;
                  const y = 280 - (item.caseFolders / 1000) * 220;
                  return `${x},${y}`;
                })
                .join(" ")}
            />

            <polyline
              fill="none"
              stroke="#00B074"
              strokeWidth="3"
              strokeLinecap="round"
              strokeLinejoin="round"
              points={chartData
                .map((item, index) => {
                  const x = 80 + index * 80;
                  const y = 280 - (item.payments / 1000) * 220;
                  return `${x},${y}`;
                })
                .join(" ")}
            />

            {chartData.map((item, index) => {
              const x = 80 + index * 80;
              const yBlue = 280 - (item.caseFolders / 1000) * 220;
              const yGreen = 280 - (item.payments / 1000) * 220;
              const isHighlight = item.month === "Apr";

              return (
                <g key={item.month}>
                  {isHighlight && (
                    <>
                      <circle
                        cx={x}
                        cy={yBlue}
                        r={8}
                        fill="white"
                        stroke="#2563EB"
                        strokeWidth="3"
                      />
                      <circle
                        cx={x}
                        cy={yGreen}
                        r={8}
                        fill="white"
                        stroke="#00B074"
                        strokeWidth="3"
                      />
                    </>
                  )}
                  <text
                    x={x}
                    y={300}
                    textAnchor="middle"
                    fill="#6B7280"
                    fontSize="12"
                  >
                    {item.month}
                  </text>
                </g>
              );
            })}
          </svg>
        </div>
      </div>
    </div>
  );
};

export default Overview;
